export default `<svg id="toggle-panel-btn" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512;width: 20px;height: 20px;" xml:space="preserve" class="">
<g>
   <circle cx="12" cy="12" r="2" fill="#ffffff" opacity="1" data-original="#000000" class=""></circle>
   <circle cx="4" cy="12" r="2" fill="#ffffff" opacity="1" data-original="#000000" class=""></circle>
   <circle cx="20" cy="12" r="2" fill="#ffffff" opacity="1" data-original="#000000" class=""></circle>
</g>
</svg>`
